import React, { useState } from "react";
import NewImmediateprocess from "./NewImmediateprocess";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import Footer from "../../Component/Footer";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter";
import TemplateImmediateProduction from "./TemplateImmediateProduction";
import UpArrow from "../../images/Icons/up-arrow.png";

const ImmediateProduction = () => {
  const [type, setType] = useState("Default");
  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card card-info">
          <ol className="breadcrumb float-sm-right">
            {/* <li className=" text-secondary">
              <Link
                as="button"
                className=" text-secondary"
                to="/immediateproduction"
              >
                ❮ Back &nbsp;&nbsp;
              </Link>
            </li> */}
            <li className="breadcrumb-item text-secondary">
              <Link to="/production">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/immediateproduction">Immediate production</Link>
            </li>
            <li className="breadcrumb-item active">New Immediate production</li>
          </ol>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header">
                      <h3 className="card-title">New Immediate production</h3>
                    </div> */}
                    <div className="card">
                      <div className="form-row">
                        <fieldset className="form-group col-md-12 tw-ml-7 mt-3">
                          <div className="d-flex gap-2 m-2 tw-ml-4">
                            <fieldset
                              className={`tab-button mr-2 ${type === "Default" ? "active-tab" : "inactive-tab"}`}
                              onClick={() => setType("Default")}
                              disabled={type === "Default"}
                            >
                              Default
                              <img
                                src={UpArrow}
                                alt="Up Arrow"
                                style={{
                                  marginLeft: "4px",
                                  width: "1.5rem",
                                  height: "1.5rem",
                                  padding: "4px",
                                  transform: "rotate(30deg)",
                                }}
                              />
                            </fieldset>

                            <fieldset
                              className={`tab-button mr-2 ${type === "Using Template" ? "active-tab" : "inactive-tab"}`}
                              onClick={() => setType("Using Template")}
                              disabled={type === "Using Template"}
                            >
                              Using Template
                              <img
                                src={UpArrow}
                                alt="Up Arrow"
                                style={{
                                  marginLeft: "4px",
                                  width: "1.5rem",
                                  height: "1.5rem",
                                  padding: "4px",
                                  transform: "rotate(30deg)",
                                }}
                              />
                            </fieldset>
                          </div>

                        </fieldset>
                      </div>

                      {type === "Using Template" ? <TemplateImmediateProduction /> : <NewImmediateprocess />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(ImmediateProduction);
